import * as apiKey from './api-key'
import * as appBundle from './app-bundle'
import * as appDefinition from './app-definition'
import * as appInstallation from './app-installation'
import * as appUpload from './app-upload'
import * as asset from './asset'
import * as assetKey from './asset-key'
import * as contentType from './content-type'
import * as editorInterface from './editor-interface'
import * as entry from './entry'
import * as environment from './environment'
import * as environmentAlias from './environment-alias'
import * as extension from './extension'
import * as locale from './locale'
import * as organization from './organization'
import * as organizationInvitation from './organization-invitation'
import * as organizationMembership from './organization-membership'
import * as personalAccessToken from './personal-access-token'
import * as previewApiKey from './preview-api-key'
import * as role from './role'
import * as scheduledAction from './scheduled-action'
import * as snapshot from './snapshot'
import * as space from './space'
import * as spaceMember from './space-member'
import * as spaceMembership from './space-membership'
import * as team from './team'
import * as teamMembership from './team-membership'
import * as tag from './tag'
import * as teamSpaceMembership from './team-space-membership'
import * as upload from './upload'
import * as usage from './usage'
import * as user from './user'
import * as webhook from './webhook'

export default {
  appBundle,
  apiKey,
  appDefinition,
  appInstallation,
  appUpload,
  asset,
  assetKey,
  contentType,
  editorInterface,
  entry,
  environment,
  environmentAlias,
  extension,
  locale,
  organization,
  organizationInvitation,
  organizationMembership,
  personalAccessToken,
  previewApiKey,
  role,
  scheduledAction,
  snapshot,
  space,
  spaceMember,
  spaceMembership,
  tag,
  team,
  teamMembership,
  teamSpaceMembership,
  upload,
  usage,
  user,
  webhook,
}
